import React from 'react'
import classNames from 'classnames'
import PrivacyPolicy from './PrivacyPolicy'

interface PrivacyPolicyModalProps {
  isOpen: boolean
  onClose: () => void
}

const PrivacyPolicyModal = (props: PrivacyPolicyModalProps) => {
  const {isOpen, onClose} = props
  return (
    <div
      className={classNames({
        modal: true,
        'modal-open': isOpen
      })}
    >
      <div className="modal-box p-8">
        <div className="flex flex-row w-full justify-end">
          <button
            className="btn btn-sm btn-circle btn-primary"
            onClick={() => onClose()}
          >
            ✕
          </button>
        </div>
        <PrivacyPolicy />
        <div className="modal-action">
          <button className="btn btn-primary" onClick={() => onClose()}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicyModal
